// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DrawPointer, DrawPointerTypeEnum } from '../Utils/DrawPointer';
import { TerceraChartBaseRenderer } from './TerceraChartBaseRenderer';
import { TerceraChartCashItemSeriesDataType } from '../Series/TerceraChartCashItemSeriesEnums';
import { LayersEnum } from '../Utils/LayersEnum';
export class TerceraChartOverlayStorageRenderer extends TerceraChartBaseRenderer {
    get UseInAutoscale() {
        return true;
    }
    set UseInAutoscale(value) {
        // this._UseInAutoscale = value;
    }
    constructor(chart) {
        super(chart);
        this.OverlaysWindows = [];
        this._UseInAutoscale = true;
        this.SetClassName('TerceraChartOverlayStorageRenderer');
    }
    IsNeedDraw(numberOfLayer) {
        return this.assignLayer === numberOfLayer || LayersEnum.Quotes === numberOfLayer;
    }
    Draw(gr, window, windowsContainer, advParams = null) {
        const adv = advParams;
        const chart = adv.TerceraChart;
        const mainWindow = chart.mainWindow;
        const OverlaysWindows = this.OverlaysWindows;
        for (let i = 0; i < OverlaysWindows.length; i++) {
            const workOverlay = OverlaysWindows[i];
            if (!workOverlay.Overlay.SeparateScaleGet()) {
                // Use params from the main symbol
                workOverlay.MoveY(mainWindow.FminFloatY, mainWindow.FmaxFloatY);
                workOverlay.Overlay.cashItemSeriesSettings.DataType = chart.cashItemSeriesSettings.DataType;
            }
            // одни настройки на все шкалы
            workOverlay.Overlay.cashItemSeriesSettings.BasisType = chart.cashItemSeriesSettings.BasisType;
            // Replace to actual overlay data
            let overlayCopy = null;
            if (advParams) {
                overlayCopy = Object.assign({}, advParams);
                // overlayCopy = jQuery.extend(true, {}, advParams);// { ...advParams };
                overlayCopy.Instrument = workOverlay.Overlay.ActiveInstrument;
                overlayCopy.mainPriceRenderer = workOverlay.Overlay.mainPriceRenderer;
            }
            // рисование маркера на активном оверлее, или если оверлей на основной шкале
            if (workOverlay.Overlay.ShowMarker &&
                (overlayCopy === null || overlayCopy === void 0 ? void 0 : overlayCopy.Instrument) !== null &&
                (workOverlay.Overlay === workOverlay.Overlay.chart.ActiveOverlayGet() ||
                    !workOverlay.Overlay.SeparateScaleGet())) {
                const cashItemSeries = workOverlay.Overlay.mainPriceRenderer.Series;
                if (cashItemSeries) {
                    const ci = cashItemSeries.CashItem;
                    const ciAC = ci.FNonEmptyCashArrayCount - 1;
                    if (ciAC >= 0) {
                        let value = ci.getLastPrice();
                        let text = overlayCopy.Instrument.formatPrice(value);
                        const dataType = cashItemSeries !== null
                            ? cashItemSeries.settings.DataType
                            : TerceraChartCashItemSeriesDataType.Absolute;
                        switch (dataType) {
                            case TerceraChartCashItemSeriesDataType.Relative:
                                value = cashItemSeries.settings.relativeDataConverter.Calculate(value);
                                text = value.toFixed(2) + '%';
                                break;
                            case TerceraChartCashItemSeriesDataType.Log:
                                value = cashItemSeries.settings.logDataConverter.Calculate(value);
                                break;
                        }
                        if (advParams.layerId === LayersEnum.Quotes) {
                            if (workOverlay.Overlay.SeparateScaleGet()) {
                                overlayCopy.DrawPointers.push(new DrawPointer(DrawPointerTypeEnum.Overlay, value, workOverlay.Overlay.MarkerBrush, text));
                            }
                            else if (advParams) {
                                advParams.DrawPointers.push(new DrawPointer(DrawPointerTypeEnum.Overlay, value, workOverlay.Overlay.MarkerBrush, text));
                            }
                        }
                    }
                }
            }
            workOverlay.Draw(gr, chart.windowsContainer, overlayCopy);
        }
    }
    CalculateMinMax() {
        for (let i = 0; i < this.OverlaysWindows.length; i++) {
            this.OverlaysWindows[i].CalculateMinMax();
        }
    }
    ProcessMouseMove(e) {
        let res = super.ProcessMouseMove(e);
        // Overlays?
        if (!res) {
            for (let i = 0; i < this.OverlaysWindows.length; i++) {
                for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                    res = this.OverlaysWindows[i].Renderers[j].ProcessMouseMove(e);
                    if (res) {
                        return res;
                    }
                }
            }
        }
        return res;
    }
    ProcessMouseDown(e) {
        let res = super.ProcessMouseDown(e);
        // Overlays?
        if (!res) {
            for (let i = 0; i < this.OverlaysWindows.length; i++) {
                for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                    res = this.OverlaysWindows[i].Renderers[j].ProcessMouseDown(e);
                    if (res) {
                        return res;
                    }
                }
            }
        }
        return res;
    }
    ProcessMouseUp(e) {
        // Base processing
        let res = super.ProcessMouseUp(e);
        // Overlays
        if (!res) {
            for (let i = 0; i < this.OverlaysWindows.length; i++) {
                for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                    res = this.OverlaysWindows[i].Renderers[j].ProcessMouseUp(e);
                    if (res) {
                        return res;
                    }
                }
            }
        }
        return res;
    }
    ProcessMouseClick(e) {
        let res = super.ProcessMouseClick(e);
        // Overlays?
        if (!res) {
            for (let i = 0; i < this.OverlaysWindows.length; i++) {
                for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                    res = this.OverlaysWindows[i].Renderers[j].ProcessMouseClick(e);
                    if (res) {
                        return res;
                    }
                }
            }
        }
        return res;
    }
    ProcessMouseEnter(e) {
        // Base processing
        super.ProcessMouseEnter(e);
        // Overlays
        for (let i = 0; i < this.OverlaysWindows.length; i++) {
            for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                this.OverlaysWindows[i].Renderers[j].ProcessMouseEnter(e);
            }
        }
    }
    ProcessMouseLeave(e) {
        // Base processing
        super.ProcessMouseLeave(e);
        // Overlays
        for (let i = 0; i < this.OverlaysWindows.length; i++) {
            for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                this.OverlaysWindows[i].Renderers[j].ProcessMouseLeave(e);
            }
        }
    }
    GetContextMenu(e, chart) {
        const contextMenu = super.GetContextMenu(e, chart);
        if (isValidArray(contextMenu)) {
            return contextMenu;
        }
        for (let i = 0; i < this.OverlaysWindows.length; i++) {
            for (let j = 0; j < this.OverlaysWindows[i].Renderers.length; j++) {
                const overlayContextMenu = this.OverlaysWindows[i].Renderers[j].GetContextMenu(e, chart);
                if (isValidArray(overlayContextMenu)) {
                    return overlayContextMenu;
                }
            }
        }
        return super.GetContextMenu(e, chart);
    }
    LayoutWindows() {
        // Layout overlays
        for (let i = 0; i < this.OverlaysWindows.length; i++) {
            this.OverlaysWindows[i].Rectangle = this.chart.mainWindow.Rectangle;
            this.OverlaysWindows[i].OnLayout();
        }
    }
    ThemeChanged() {
        super.ThemeChanged();
        if (isValidArray(this.OverlaysWindows)) {
            for (let i = 0; i < this.OverlaysWindows.length; i++) {
                this.OverlaysWindows[i].ThemeChanged();
            }
        }
    }
    Dispose() {
        this.chart = null;
        super.Dispose();
    }
}
